import React, { Fragment, useState, useContext } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { Loading, AddUpdateClose, Dateonly } from "../../components";
import { useMutation } from "@apollo/react-hooks";
import alertify from "alertifyjs";
import { companiesMutations, companiesQueries } from "../../resolvers";
import _ from "lodash";
import { CompaniesContext } from "../../contexts";
import { isMobile } from "react-device-detect";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: isMobile ? 0 : theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: isMobile ? "1em" : "3em",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: (state) =>
      state.page !== "update"
        ? theme.palette.primary.main
        : theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: "4em",
  },
}));

export default function AddUpdate({ currentcompany }) {
  const { state, setState } = useContext(CompaniesContext);
  const changeState = (value) => {
    setState({ ...state, ...value });
  };

  const { data } = state.addUpdate;
  const { variables } = state.pageList;

  const [initialState, setInitialState] = useState({ ...data });
  const [initialError, setInitialError] = useState({});
  const [initialStyle, setInitialStyle] = useState({ page: state.page });

  const classes = useStyles({ ...initialStyle });

  const handleChange = (event) => {
    if (event.target.name === "userlimit") {
      setInitialState({
        ...initialState,
        [event.target.name]: event.target.value
          ? Number(event.target.value)
          : 0,
      });
    } else {
      setInitialState({
        ...initialState,
        [event.target.name]: event.target.value,
      });
    }
    setInitialError({
      ...initialError,
      [event.target.name]: event.target.value ? false : true,
    });
  };

  const handleChangeIsActive = (event) => {
    setInitialState({
      ...initialState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangePassiveDate = (date) => {
    setInitialState({ ...initialState, passiveDate: date });
  };

  const [save, { loading }] = useMutation(companiesMutations.COMPANY_CREATE, {
    onCompleted(data) {
      alertify.success("Kaydınız Başarıyla Yapılmıştır.", 4);
    },
    update(cache, { data: companyCreate }) {
      const { Companies } = cache.readQuery({
        query: companiesQueries.COMPANIES,
        variables
      });

      cache.writeQuery({
        query: companiesQueries.COMPANIES,
        variables,
        data: {
          Companies: [companyCreate.companyCreate, ...Companies],
        },
      });
    },
    onError(err) {
      console.log(err)
      let x = err.message.split(":", 3);
      alertify.error(x[2], 3);
    },
  });

  const [update, { loading: loadingUpdate }] = useMutation(
    companiesMutations.COMPANY_UPDATE,
    {
      onCompleted(data) {
        alertify.success("Kaydınız Başarıyla Güncellenmiştir.", 4);
      },
      update(cache, { data: companyUpdate }) {
        if (companyUpdate.companyUpdate.ok > 0) {
          const { Companies } = cache.readQuery({
            query: companiesQueries.COMPANIES,
            variables
          });

          const index = _.findIndex(Companies, { id: data.id });
          Companies.splice(index, 1, { ...initialState });

          cache.writeQuery({
            query: companiesQueries.COMPANIES,
            variables,
            data: {
              Companies,
            },
          });


        }
      },
      onError(err) {
        let x = err.message.split(":", 3);
        alertify.error(x[2], 3);
      },
    }
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validate()) {
      alertify.error("Lütfen Gerekli Alanları Doldurunuz.", 3);
    } else {
      if (state.page === "update") {
        const oldData = { ...data };
        const oldKeys = Object.keys(oldData);
        const initialKeys = Object.keys(initialState);
        const keys = _.union(oldKeys, initialKeys);
        let Variables = { data: { id: oldData.id } };
        let isChanged = false;

        await keys.map((x) => {
          if (oldData[x] !== initialState[x] && x !== "__typename") {
            Variables.data[x] = initialState[x];
            isChanged = true;
          }
        });
        if (isChanged) {
          update({ variables: Variables });
        }

        else alertify.error("Güncellenecek veri bulunamadı.", 4);
      } else {
        save({
          variables: {
            data: { ...variableChecker(initialState) },
          },
        });
      }
    }
  };

  const variableChecker = (data) => {
    const keys = Object.keys(data);
    let Data = {};
    for (let i of keys) {
      if (data[i]) {
        Data[i] = data[i];
      }
    }
    return Data;
  }

  const validate = () => {
    const { name, type } = initialState;
    setInitialError({
      ...initialError,
      name: !name,
      type: !type,
    });
    return !name || !type;
  };

  if (loading || loadingUpdate) return <Loading />;
  return (
    <Fragment>
      <Container maxWidth="sm">
        <CssBaseline />
        <AddUpdateClose changeState={changeState} state={state} />
        <Paper className={classes.paper} elevation={2}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Avatar className={classes.avatar}>
              <QuestionAnswerIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              {state.page === "update"
                ? "Eğitim Kurumunu Güncelle"
                : "Eğitim Kurumu Oluştur"}
            </Typography>
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    onChange={handleChange}
                    value={initialState.name}
                    error={initialError.name}
                    name="name"
                    variant="outlined"
                    fullWidth
                    id="name"
                    label="Firma"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    onChange={handleChange}
                    value={initialState.type}
                    error={initialError.type}
                    name="type"
                    variant="outlined"
                    fullWidth
                    id="type"
                    label="Tipi"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    onChange={handleChange}
                    value={initialState.userlimit}
                    //error={initialError.userlimit}
                    name="userlimit"
                    variant="outlined"
                    fullWidth
                    type="number"
                    id="userlimit"
                    label="Kullanıcı Sayısı"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Dateonly
                    name="passiveDate"
                    label="Pasif Tarihi"
                    value={initialState.passiveDate}
                    onChange={handleChangePassiveDate}
                    //error={initialError.passiveDate ? true : false}
                    autoOk={false}
                    fullWidth
                    margin="normal"
                    disablePast
                    format="dd.MM.yyyy"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    onChange={handleChange}
                    value={initialState.description}
                    //error={initialError.description}
                    name="description"
                    variant="outlined"
                    multiline
                    fullWidth
                    id="description"
                    label="Açıklama"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={initialState.isActive}
                        onChange={handleChangeIsActive}
                        name="isActive"
                        color={
                          state.page !== "update" ? "primary" : "secondary"
                        }
                      />
                    }
                    label="Aktif"
                  />
                </Grid>
              </Grid>

              <Grid item style={{ marginTop: 16 }}></Grid>
              <Grid
                item
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
              >
                {state.page === "update" ? (
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="secondary"
                    className={classes.submit}
                  >
                    Güncelle
                  </Button>
                ) : (
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                    >
                      Kaydet
                    </Button>
                  )}
              </Grid>
            </form>
          </Grid>
        </Paper>
      </Container>
    </Fragment>
  );
}
